import { gql } from "@apollo/client";

export const GET_FILE_UPLOAD_MENUS = gql`
  query fileUploadMenus {
    getCounties {
      value
      label
    }
    getWaterSystemsAndCounties {
      value
      label
      countyId
      county
    }
    getFileUploadFileTypes {
      value
      label
    }
  }
`;

export const UPLOAD_FILE = gql`
  mutation AddFileUpload(
    $systemId: Int!
    $fileName: String!
    $fileDescription: String
    $pws_id: String!
    $ddwFileType: Int!
    $ddwFileSubtype: Int
    $fileType: String!
    $filePath: String!
    $fileSize: Int!
    $isSystemRep: Boolean
    $gis: Boolean
    $lslCert: Boolean
    $createdBy: String!
  ) {
    addFileUpload(
      AddFileUpload: {
        systemId: $systemId
        fileName: $fileName
        fileDescription: $fileDescription
        pws_id: $pws_id
        ddwFileType: $ddwFileType
        ddwFileSubtype: $ddwFileSubtype
        fileType: $fileType
        filePath: $filePath
        fileSize: $fileSize
        gis: $gis
        lslCert: $lslCert
        isSystemRep: $isSystemRep
        createdBy: $createdBy
      }
    ) {
      recordId
    }
  }
`;

export const GET_LSL_VALIDATION_FAILURES = gql`
  query getFileValidation($filePath: String!) {
    getFileValidation(filePath: $filePath) {
      failureCount
      failures {
        pwsInformation
        inventorySummary
        inventoryMethods
        detailedInventory
        publicAccessibility
      }
    }
  }
`;
